import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { TAB_SET } from '../../constants/OfficeTabs';

export default function OfficeTabs() {
  const { base, tabs } = TAB_SET;
  return (
    <div className="align-self-start w-100">
      <Nav variant="tabs" className="mb-3">
        {tabs.map((t) => (
          <Nav.Item key={t.path}>
            <Nav.Link as={NavLink} to={`${base}/${t.path}`} end>
              {t.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
}
